import * as z from 'zod';

import { aPIKeyFormSchema } from './api-keys-schemas';
import { connectedAppQuerySchema } from './connected-app-query-schema';

import { authenticationTypeFormSchema } from '../components/authentication-type';

export const connectedAppFormSchema = connectedAppQuerySchema
  .omit({
    legal_entity_id: true,
    brand_id: true,
  })
  .extend({
    description: z.string(),
    api_keys: z.array(aPIKeyFormSchema),
    authentication_type: authenticationTypeFormSchema,
    client_secret: z.string(),
    authorization_url: z.string(),
    client_id: z.string(),
  })
  .refine(
    (data) => {
      return data.authentication_type.value === 'oauth' ? data.client_secret.trim() !== '' : true;
    },
    {
      message: 'Client Secret is required',
      path: ['client_secret'],
    }
  )
  .refine(
    (data) => {
      return data.authentication_type.value === 'oauth' ? data.authorization_url.trim() !== '' : true;
    },
    {
      message: 'Authorization URL is required',
      path: ['authorization_url'],
    }
  )
  .refine(
    (data) => {
      return data.authentication_type.value === 'oauth' ? data.client_id.trim() !== '' : true;
    },
    {
      message: 'Client ID is required',
      path: ['client_id'],
    }
  );

export type ConnectedAppFormSchema = z.infer<typeof connectedAppFormSchema>;
